import { render, staticRenderFns } from "./PBD.vue?vue&type=template&id=3dd9469c&scoped=true&"
import script from "./PBD.vue?vue&type=script&lang=js&"
export * from "./PBD.vue?vue&type=script&lang=js&"
import style0 from "./PBD.vue?vue&type=style&index=0&id=3dd9469c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd9469c",
  null
  
)

export default component.exports